import {
  Popover,
  IconButton,
  Typography,
  PopoverOrigin,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Trans } from "react-i18next"

const styles = {
    popoverBoxSx: {
        overflow: "visible",
        zIndex: 1400,
    },
    popoverSlotPropsPaperSx: {
        p: 2,
        pt: 3,
        pl: 5,
        pr: 3,
        boxShadow: 3,
        overflow: "visible",
        position: "relative",
        borderRadius: "0px",
    },
    closeIconSx: {
        position: "absolute",
        top: "-18px",
        left: "-18px",
        backgroundColor: "#00567c",
        color: "white",
        width: 36,
        height: 36,
        borderRadius: "50%",
        boxShadow: 2,
        zIndex: 10,
        "&:hover": { backgroundColor: "#004452" },
    }
}

interface CommonCustomTooltipProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  content: string;
  maxWidth?: number;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
}

export const CommonCustomTooltip = (props: CommonCustomTooltipProps) => {
    const { open, anchorEl, onClose, content, anchorOrigin, transformOrigin, maxWidth } = props;
    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={(event, reason) => {
                if (reason === "escapeKeyDown") {
                  onClose();
                }
              }}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            sx={{...styles.popoverBoxSx}}
            slotProps={{
                paper: {
                sx: {...styles.popoverSlotPropsPaperSx, maxWidth: maxWidth ?? 280},
                },
            }}
        >
        <IconButton
            onClick={onClose}
            sx={{...styles.closeIconSx}}
        >
            <CloseIcon sx={{ fontSize: 20 }} />
        </IconButton>
        <Typography sx={{ fontSize: "0.9rem" }}>
            <Trans i18nKey={content} components={{ sup: <sup />, bold: <strong />, br: <br /> }} />
        </Typography>
        </Popover>
    );
};